import React from 'react';
import {ClearIndicatorProps, DropdownIndicatorProps, components} from 'react-select';
import DownArrow from '../../../assests/img/down-arrow-grey-icon.svg?react';
import CloseIcon from '../../../assests/img/close-icon-grey.svg?react';


const CustomDropdownIndicator = (
    props: DropdownIndicatorProps<{value: string, label: string}>,
) =>  (
    <components.DropdownIndicator {...props}>
        <DownArrow/>
    </components.DropdownIndicator>
);

export const CustomDropdownClearIndicator = (
    props: ClearIndicatorProps<{value: string, label: string}>,
) =>  (
    <components.ClearIndicator {...props} className='px-0'>
        <CloseIcon width={8} height={8}/>
    </components.ClearIndicator>
);

export default CustomDropdownIndicator;

